import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-signup-form',
			block: '.js-sign-up',

			dom: {
				site: '#site',
				shop: '#shop'
			},
			classes: {
				el: {
					state: {
						active: 'signup-form_state_active'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		this.$site = this.$el.find(this.options.dom.site);
		this.$shop = this.$el.find(this.options.dom.shop);
		this.active = this.options.classes.el.state.active;
		return this;
	}

	open(e) {
		const $target = $(e.target);
		const $el = $target.closest(this.$el);
		$el.addClass(this.active);
	}

	close(e) {
		const $target = $(e.target);
		const $el = $target.closest(this.$el);
		$el.removeClass(this.active);
	}

	fullBgImage() {
		const imgAttr = {
			src: '/images/sign-up/bg-signup.jpg'
		};
		const img = $('<img />', {
			src: imgAttr.src
		});
		img.load(function () {
			$('.sign-up').css({
				background: 'url(' + imgAttr.src + ') no-repeat center / cover'
			});
		});
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$shop.on('click', e => this.open(e));
			this.$site.on('click', e => this.close(e));

			if (document.body.querySelectorAll(this.options.block).length > 0) {
				this.fullBgImage();
			}

			this.$el.find('input').focus( function () {
				$(this).data('placeholder', $(this).attr('placeholder'));
				$(this).attr('placeholder', '');
			});

			this.$el.find('input').blur( function () {
				$(this).attr('placeholder', $(this).data('placeholder'));
			});
		}
		return this;
	}
}
